<div class="full-page">
  <div class="full-page__header">
    <div class="full-page__header--cont main-container">
      <h2>Help By Topics</h2>
      <button (click)="closeHelpTopics()" class="close-btn">
        <span class="material-icons"> close </span> Close
      </button>
    </div>
  </div>
  <div class="full-page__cont help-topics">
    <div class="main-container">
      <div class="help-topics__title">
        <h3>Help By Topics</h3>
      </div>
      <div class="help-topics__body pb-5">
        <div fxLayout="row" fxLayoutGap="20px">
          <div fxFlex="30">
            <div class="help-topics__names">
              <button
                *ngFor="let item of helpTopicsList; let i = index"
                (click)="selectTab(i)"
                [class.active]="i === selectedIndex">
                {{ item.topic }}
              </button>
            </div>
          </div>
          <div fxFlex="70">
            <div class="tab-contents">
              <div
                *ngFor="let tab of helpTopicsList; let i = index"
                class="tab-content"
                [class.active]="i === selectedIndex">
                <p>{{ tab.description }}</p>
                <div class="help-video__row">
                  <div
                    class="help-video__col"
                    *ngFor="let item of tab.subTopics; let j = index">
                    <span class="video-title">{{ item.subTopic }}</span>
                    <button
                      (click)="toggleVideoPopup(item?.file_Url)"
                      type="button">
                      <span class="material-icons"> smart_display </span>
                      Watch Demo
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="help-topics__footer">
              <button
                class="primary-btn-link mr-8"
                (click)="prevTab()"
                [disabled]="selectedIndex === 0">
                <span class="material-icons"> arrow_back </span>
                Previous Topic
              </button>
              <button
                class="primary-btn-link"
                (click)="nextTab()"
                [disabled]="selectedIndex === helpTopicsList.length - 1">
                Next Topic
                <span class="material-icons"> arrow_forward </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-modal" *ngIf="videoPopup">
        <div class="modal-popup pa-2">
          <div class="video-header">
            <button
              class="primary-btn link"
              (click)="toggleVideoPopup()"
              type="button">
              <span class="material-icons"> close </span>
            </button>
          </div>
          <div class="video-body">
            <video width="100%" height="460" controls autoplay>
              <source [src]="videoFile" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
